var styles = {"root":"Toast-module_root__2rxFV","wrapper":"Toast-module_wrapper__sfSWZ","success":"Toast-module_success__3viVI","error":"Toast-module_error__2fCRm","closeButton":"Toast-module_closeButton__3GScH","closeIcon":"Toast-module_closeIcon__3CWh-"};

export { styles as default };
//# sourceMappingURL=Toast.module.css.js.map
